// ** Store & Actions
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { getUser } from "@store/stores/user"
import { getCookie } from "@lib/util"

// ** HOC to dispatch getUser action manually.
// ** Not a good solution as is, but it's the only way to have the user store
// ** available for the whole app since auth is done in MVC C# and we cannot
// ** set the store values via actions from over there.
const CustomStoreWrapper = ({ children }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    const userId = getCookie("user.ID", false)
    dispatch(getUser(userId))
  }, [dispatch, getCookie, getUser])

  return <>{children}</>
}

export default CustomStoreWrapper
